/*!
* Merge Sort in JavaScript v1.0
* http://github.com/justinforce/merge-sort
*
* Copyright (c) 2011, Justin Force
* Licensed under the BSD 3-Clause License
*/
angular
  .module('fca-used')
  .constant('mergeSort', mergeSort);

function mergeSort(array, compare) {
  var length = array.length;
  var middle = Math.floor(length / 2);

  // define default comparison function if none is defined
  if (!compare) {
    compare = function (left, right) {
      if (left < right) {
        return -1;
      }
      if (left === right) {
        return 0;
      }
      return 1;
    };
  }

  if (length < 2) {
    return array;
  }

  function merge(left, right, compare) {
    var result = [];

    while (left.length > 0 || right.length > 0) {
      if (left.length > 0 && right.length > 0) {
        if (compare(left[0], right[0]) <= 0) {
          result.push(left[0]);
          left = left.slice(1);
        } else {
          result.push(right[0]);
          right = right.slice(1);
        }
      } else if (left.length > 0) {
        result.push(left[0]);
        left = left.slice(1);
      } else if (right.length > 0) {
        result.push(right[0]);
        right = right.slice(1);
      }
    }
    return result;
  }

  return merge(
    mergeSort(array.slice(0, middle), compare),
    mergeSort(array.slice(middle, length), compare),
    compare
  );
}

